import axios from "axios"
import { get } from "lodash"

export const getLocation = async () => {
  const countryData = await axios.get('https://ipapi.co/json/')
  const location = []
  if (countryData.data && countryData.data.city)
    location.push(countryData.data.city)

  if (countryData.data && countryData.data.country_name)
    location.push(countryData.data.country_name)

  return location.join(', ')
}

export const getCountry = async () => {
  const countryData = await axios.get('https://ipapi.co/json/')

  return get(countryData, 'data.country_name', 'India')
}